import React from "react";
import { useSelector } from "react-redux";

import "./SuspendedProjectsDashboard.scss";

// Icons & Packages
import DropdownAngle from "assets/icons/dropdown-angle.svg";
import DropdownAngleLight from "assets/icons/dropdown-angle-light.svg";
import SPIcon from "assets/icons/suspended.svg";
import Construction from "assets/icons/construction-new.svg";
import Renovation from "assets/icons/renovation-new.svg";
import Support from "assets/icons/heart-new.svg";
import Transformation from "assets/icons/transformation-new.svg";
import STIcon from "assets/icons/suspended-tileicon.svg";
import WalletBlue from "assets/icons/wallet-blue.svg";
import NoteSmallWhiteIcon from "assets/icons/notesmall-white.svg";
import NoteSmallWhiteIconLight from "assets/icons/notesmall-white-light.svg";
import Years from "assets/icons/years.svg";
import YearsLight from "assets/icons/years-light.svg";

// Importing Components
import SmallPie from "components/charts/SmallPie";
import LargePie from "components/charts/LargePie";

const SuspendedProjectsDashboard = () => {
  const selectedTheme = useSelector((state) => state.globalConfig.theme);
  return (
    <>
   {/* Dropdowns Wrapper */}
   <section className="dropdowns-wrapper">
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Central</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Eastern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          <img src={DropdownAngle} alt="#" />
          <select>
            <option>North Western</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Northern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>S. Project</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Southern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
      </section>

      {/* Timeoverrun Projects Pane */}
      <section className="suspended-projects-wrapper">
        <div className="suspended-projects-container">
          <div className="suspended-title">
            <img src={SPIcon} alt="#" />
            <span>Suspended Projects</span>
          </div>
          <div className="suspended-list">
            <ul>
              <li>
                <span>Western </span>
                <span>29%</span>
              </li>
              <li>
                <span>Northern East </span>
                <span>17.5%</span>
              </li>
              <li>
                <span>South West </span>
                <span>44.33%</span>
              </li>
              <li>
                <span>Western </span>
                <span>26.09%</span>
              </li>
              <li>
                <span>Northen East </span>
                <span>17.39%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Left Section Slice middle And Right Section Slice Info */}
      <div className="suspended-grid-wrapper">
        <div className="left-section">
          <div className="top">
            <div className="s-projects-cover">
              <div className="icon-title">
                <div className="icon-cover">
                  <img src={STIcon} alt="suspendedicon" />
                </div>
                <div className="tile-name">
                  <span>Projects</span>
                </div>
              </div>
              <div className="sp-count">
                <span>90</span>
              </div>
            </div>
            <div className="s-projects-cover">
              <div className="icon-title">
                <div className="icon-cover">
                  <img src={WalletBlue} alt="suspendedicon" />
                </div>
                <div className="tile-name">
                  <span>Budget</span>
                </div>
              </div>
              <div className="sp-count blue-count">
                <span>4.16bn</span>
                <span className="sp-currency">SAR</span>
              </div>
            </div>
          </div>
        </div>
        <div className="middle-first-section">
          <div className="suspension-type-wrapper">
            <div className="suspension-type-status-container">
              <div className="header">
                <span>
                {selectedTheme === "dark" ? (
                    <img src={NoteSmallWhiteIcon} alt="#" />
                  ) : (
                    <img src={NoteSmallWhiteIconLight} alt="#" />
                  )}
                  Suspension Type
                </span>
              </div>

              <div className="chart-container">
                <div className="chart">
                  <SmallPie colorset={["#E9631C", "#8C3B11"]} />
                </div>
                <div className="charts-count">
                  <span>Northern</span>
                  <span className="orange-text">6</span>
                </div>
              </div>
              <div className="chart-container">
                <div className="chart">
                  <SmallPie colorset={["#E9631C", "#8C3B11"]} />
                </div>
                <div className="charts-count">
                  <span>Southern</span>
                  <span className="orange-text">10</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="right-section">
          <div className="suspended-classification-container">
            <div className="header">
              <span>
              {selectedTheme === "dark" ? (
                    <img src={NoteSmallWhiteIcon} alt="#" />
                  ) : (
                    <img src={NoteSmallWhiteIconLight} alt="#" />
                  )}
                Suspended Projects Baseline By Year
              </span>
            </div>
            <div className="chart-container">
              <div className="chart-wrapper">
                <div className="horizontal-bar-container">
                  <div className="info">
                    <span>2011</span>
                  </div>
                  <div className="horizontal-bar">
                    <span>46</span>
                    <div className="bar" style={{ width: "46%" }}>
                      <div className="progress">
                        <div className="glow"></div>
                      </div>
                    </div>
                  </div>

                  <div className="horizontal-bar blue">
                    <div className="bar" style={{ width: "33%" }}>
                      <div className="progress">
                        <div className="glow"></div>
                      </div>
                    </div>
                    <span>33</span>
                  </div>
                </div>

                <div className="horizontal-bar-container">
                  <div className="info">
                    <span>2012</span>
                  </div>
                  <div className="horizontal-bar">
                    <span>86</span>
                    <div className="bar" style={{ width: "86%" }}>
                      <div className="progress">
                        <div className="glow"></div>
                      </div>
                    </div>
                  </div>

                  <div className="horizontal-bar blue">
                    <div className="bar" style={{ width: "75%" }}>
                      <div className="progress">
                        <div className="glow"></div>
                      </div>
                    </div>
                    <span>75</span>
                  </div>
                </div>
                <div className="horizontal-bar-container">
                  <div className="info">
                    <span>2015</span>
                  </div>
                  <div className="horizontal-bar">
                    <span>35</span>
                    <div className="bar" style={{ width: "35%" }}>
                      <div className="progress">
                        <div className="glow"></div>
                      </div>
                    </div>
                  </div>

                  <div className="horizontal-bar blue">
                    <div className="bar" style={{ width: "42%" }}>
                      <div className="progress">
                        <div className="glow"></div>
                      </div>
                    </div>
                    <span>42</span>
                  </div>
                </div>
                <div className="horizontal-bar-container">
                  <div className="info">
                    <span>2020</span>
                  </div>
                  <div className="horizontal-bar">
                    <span>68</span>
                    <div className="bar" style={{ width: "68%" }}>
                      <div className="progress">
                        <div className="glow"></div>
                      </div>
                    </div>
                  </div>

                  <div className="horizontal-bar blue">
                    <div className="bar" style={{ width: "55%" }}>
                      <div className="progress">
                        <div className="glow"></div>
                      </div>
                    </div>
                    <span>55</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="middle-second-section">
          <div className="suspension-reason-wrapper">
            <div className="suspension-reason-status-container">
              <div className="header">
                <span>
                {selectedTheme === "dark" ? (
                    <img src={NoteSmallWhiteIcon} alt="#" />
                  ) : (
                    <img src={NoteSmallWhiteIconLight} alt="#" />
                  )}
                  Reason for Suspension
                </span>
              </div>

              <div className="chart-container">
                <div className="chart">
                  <SmallPie colorset={["#6E7D87", "#424B51"]} />
                </div>
                <div className="charts-count">
                  <span>Northern</span>
                  <span className="gray-text">8</span>
                </div>
              </div>
              <div className="chart-container">
                <div className="chart">
                  <SmallPie colorset={["#24A0D9", "#166082"]} />
                </div>
                <div className="charts-count">
                  <span>Southern</span>
                  <span className="blue-text">7</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Projects Progress Graph Section */}
      <section className="projects-progress-graph-wrapper">
        <div className="projects-progress-graph-container">
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalblue"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info darkblue">
              <div className="head">
                <span>
                  <img src={Construction} alt="#" />
                  Construction Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section">
                  <span>SAR</span>
                  <span>10.30 bn</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalgreen"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info normalgreen">
              <div className="head">
                <span>
                  <img src={Renovation} alt="#" />
                  Renovation Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section white wastewater">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section white wastewater">
                  <span>SAR</span>
                  <span>10.30 bn</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalorange"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info normalorange">
              <div className="head">
                <span>
                  <img src={Transformation} alt="#" />
                  Transformation Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section white tse">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section white tse">
                  <span>SAR</span>
                  <span>10.30 bn</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalblue"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info normalblue">
              <div className="head">
                <span>
                  <img src={Support} alt="#" />
                  Supportive Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section white supportive">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section white supportive">
                  <span>Projects</span>
                  <span>10.30 bn</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*maps with three section at bottom */}
      <section className="suspended-grid-wrapper">
        <div className="left">
          <div className="header">
            <span>
            {selectedTheme === "dark" ? (
                <img src={Years} alt="#" />
              ) : (
                <img src={YearsLight} alt="#" />
              )}
              Years Of Suspension
            </span>
          </div>

          <div className="pie-info">
            <div className="year-label-container">
              <span>1 Year</span>
            </div>

            <div className="chart">
              <SmallPie colorset={["#239D9C", "#155E5E"]} />
            </div>
            <div className="title-label">
              <span>Blank</span>
            </div>
          </div>

          <div className="pie-info">
            <div className="year-label-container  year-label-2">
              <span>2 Years</span>
            </div>

            <div className="chart">
              <SmallPie colorset={["#D60000", "#800000"]} />
            </div>
            <div className="title-label  title-label-2">
              <span>6</span>
            </div>
          </div>

          <div className="pie-info">
            <div className="year-label-container  year-label-3">
              <span>5 Years</span>
            </div>

            <div className="chart">
              <SmallPie colorset={["#800000", "#4B0000"]} />
            </div>
            <div className="title-label  title-label-3">
              <span>3</span>
            </div>
          </div>
        </div>
        <div className="middle">
          <div className="header">
            <span>
              {/* <img src={Years} alt="#" /> */}
              Suspension Responsibe Authorities
            </span>
          </div>

          <div className="completed-projects-chart">
            <div className="body">
              <div className="top">
                <div className="chart-container">
                  <div className="blackhole underlay"></div>
                  <div className="blackhole"></div>
                  <div className="pie">
                    <LargePie colorset={"#6E7D87"} />
                  </div>
                </div>
                <div className="chart-per-projects">
                  <span>0.27bn</span>
                  <span>Blank</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="right">
          <div className="head">
            <span>Top Suspended Projects By Budget</span>
          </div>
          <div className="body">
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Cluster</th>
                    <th>Project Name</th>
                    <th>Budget (SAR)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Northern</td>
                    <td>أن عدم تكاليف ارتكبها</td>
                    <td>123,342,344</td>
                  </tr>
                  <tr>
                    <td>Northern</td>
                    <td>أن عدم تكاليف ارتكبها</td>
                    <td>123,342,344</td>
                  </tr>
                  <tr>
                    <td>Northern</td>
                    <td>أن عدم تكاليف ارتكبها</td>
                    <td>123,342,344</td>
                  </tr>
                  <tr>
                    <td>Northern</td>
                    <td>أن عدم تكاليف ارتكبها</td>
                    <td>123,342,344</td>
                  </tr>
                  <tr>
                    <td>Northern</td>
                    <td>أن عدم تكاليف ارتكبها</td>
                    <td>123,342,344</td>
                  </tr>
                  <tr>
                    <td>Northern</td>
                    <td>أن عدم تكاليف ارتكبها</td>
                    <td>123,342,344</td>
                  </tr>
                  <tr>
                    <td>Northern</td>
                    <td>أن عدم تكاليف ارتكبها</td>
                    <td>123,342,344</td>
                  </tr>
                  <tr>
                    <td>Northern</td>
                    <td>أن عدم تكاليف ارتكبها</td>
                    <td>123,342,344</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SuspendedProjectsDashboard;
